import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-order\"><defs><style type=\"text/css\"></style></defs><path d=\"M825.7 146H691.3c-6.3-27.5-31.7-48.7-61.4-48.7h-66.6c-8.5-21.2-28.6-34.9-51.8-34.9-23.3 0-43.4 13.8-51.8 34.9H392c-29.6 0-55 21.2-61.4 48.7H196.2c-34.9 0-61.4 28.6-61.4 63.5v683.4c0 34.9 27.5 63.5 61.4 63.5h628.4c34.9 0 64.5-28.6 64.5-63.5V209.5c1.1-34.9-28.5-63.5-63.4-63.5z m-313.2 30.7c28.6 0 50.8 23.3 50.8 50.8 0 28.6-23.3 50.8-50.8 50.8-28.6 0-50.8-23.3-50.8-50.8s22.3-50.8 50.8-50.8z m193.6 525.8c0 12.7-10.6 23.3-23.3 23.3H342.2c-12.7 0-23.3-10.6-23.3-23.3v-21.2c0-12.7 10.6-23.3 23.3-23.3h340.6c12.7 0 23.3 10.6 23.3 23.3v21.2z m0-214.8c0 12.7-10.6 23.3-23.3 23.3H342.2c-12.7 0-23.3-10.6-23.3-23.3v-21.2c0-12.7 10.6-23.3 23.3-23.3h340.6c12.7 0 23.3 10.6 23.3 23.3v21.2z\" p-id=\"3944\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order.svg
// module id = gYtG
// module chunks = 77